var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocketBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32935 15.6072L4.57319 10.1936L7.74782 13.3654L2.32935 15.6072ZM9.63808 14.6524L10.8861 11.6258L6.24173 6.99135L3.21045 8.24783L0.838547 5.87619L15.3069 0.338531L17.6005 2.62997L12.0673 17.1004L9.63808 14.6524Z",
    fill: "#2F2F2F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketBlack);
export default __webpack_public_path__ + "static/media/rocket-black.ebe3b0c0172c73f3054fa22b69182e29.svg";
export { ForwardRef as ReactComponent };